const getRouteWithVersion = (version) => {
  const pathSegments = window.location.pathname.split('/');
  const lastPath = pathSegments.pop();
  const apiVersion = devsite?.reference?.version;
  if (lastPath === apiVersion) {
    return `${window.location.origin}${pathSegments.join('/')}/${version}${window.location.hash}`;
  } else if (lastPath === 'reference') {
    return `${window.location.origin}${window.location.pathname}/v/${version}${window.location.hash}`;
  } else {
    return `${window.location.origin}${window.location.pathname}/${version}${window.location.hash}`;
  }
};

export default getRouteWithVersion;
